import React, {useEffect ,useState } from 'react';
import { ButtonWithIcon, InputBoxWraper } from '../../../constents/components';
import { GENDERS_LIST } from '../../../constants/list';
import nameInputIcon from '../../../Assets/svgs/nameInputIcon.svg';
import MobileNumberVerification from './MobileNumberVerification';

const FirstDetails = ({ details, sendToNextStep, updateFunctions }) => {
    const [isMobileNumberVerified, setIsMobileNumberVerified] = useState(false);


    const { updateFirstName, updateLastName, updateGender, updateDesignation, updateState, updateCity, updateCountry, updateMobile } = updateFunctions;
    const defaultGenderValue = "Select your Gender";

    const [errors, setErrors] = useState({
        first_name: '',
        last_name: '',
        gender: '',
        location: '',
        country: '',
        city: ''
    });

        useEffect(() => {
        if (details.location && details.city && details.country) {
            return;
        }

        if (!navigator.geolocation) {
            console.log("Geolocation is not supported by this browser.");
            return;
        }

        navigator.geolocation.getCurrentPosition(
            async (position) => {
                try {
                    const { latitude, longitude } = position.coords;

                    const response = await fetch(
                        `https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${latitude}&longitude=${longitude}&localityLanguage=en`
                    );

                    if (!response.ok) {
                        throw new Error("Unable to fetch location details");
                    }

                    const data = await response.json();

                    const detectedCountry = data.countryName || "";
                    const detectedState = data.principalSubdivision || "";
                    const detectedCity =
                        data.city ||
                        data.locality ||
                        data.principalSubdivision ||
                        "";

                    // Only populate fields that are currently empty
                    if (!details.location && detectedState) {
                        updateState(detectedState);
                    }

                    if (!details.city && detectedCity) {
                        updateCity(detectedCity);
                    }

                    if (!details.country && detectedCountry) {
                        updateCountry(detectedCountry);
                    }

                    console.log("Detected location:", {
                        country: detectedCountry,
                        state: detectedState,
                        city: detectedCity,
                    });

                } catch (error) {
                    console.error("Reverse geocoding failed:", error);
                }
            },
            (error) => {
                console.log("Location permission/error:", error);
            },
            {
                enableHighAccuracy: true,
                timeout: 10000,
                maximumAge: 300000,
            }
        );
    }, [
        details.location,
        details.city,
        details.country,
        updateState,
        updateCity,
        updateCountry,
    ]);

    const names = [
        {
            placeholder: "First Name",
            value: details.first_name,
            change: updateFirstName,
            field: 'first_name'
        },
        {
            placeholder: "Last Name",
            value: details.last_name,
            change: updateLastName,
            field: 'last_name'
        },
    ];

    const handleGenderChange = (value) => {
        updateGender(defaultGenderValue === value ? '' : value);
        if (value !== defaultGenderValue) {
            setErrors(prev => ({ ...prev, gender: '' }));
        }
    };

    const validateFields = () => {
        const newErrors = {};
        let isValid = true;

        // Validate first namee
        if (!details.first_name?.trim()) {
            newErrors.first_name = 'First name is required';
            isValid = false;
        }

        if (!details.last_name?.trim()) {
            newErrors.last_name = 'Last name is required';
            isValid = false;
        }

        if (!details.gender || details.gender === defaultGenderValue) {
            newErrors.gender = 'Please select your gender';
            isValid = false;
        }

        if (!details.location?.trim()) {
            newErrors.location = 'State is required';
            isValid = false;
        }

        if (!details.city?.trim()) {
            newErrors.city = 'City is required';
            isValid = false;
        }

        // validate Mobile Verification

        if (!isMobileNumberVerified) {
            newErrors.mobile = 'Mobile number is not verified yet';
            isValid = false;
        }
        setErrors(newErrors);
        return isValid;
    };


    const handleContinue = () => {
        if (validateFields()) {
            sendToNextStep();
        }
    };

    const handleInputChange = (change, value, field) => {
        change(value);

        if (typeof value === 'string' && value.trim()) {
            setErrors(prev => ({
                ...prev,
                [field]: ''
            }));
        }
    };



    return (
        <div className="flex gap-2 flex-col">
            <div className="my-5 flex flex-col gap-3">
                <div className="flex flex-col lg:flex-row gap-3">
                    {names.map((item, index) => (
                        <div className="flex-1" key={index}>
                            <InputBoxWraper icon={nameInputIcon} iconAltText='nameInputIcon'>
                                <input
                                    type="text"
                                    className="bg-transparent outline-none border-none"
                                    placeholder={item.placeholder}
                                    value={item.value}
                                    onChange={(e) => handleInputChange(item.change, e.target.value, item.field)}
                                />
                            </InputBoxWraper>
                            {errors[item.field] && (
                                <p className="text-sm text-red-500 mt-1">{errors[item.field]}</p>
                            )}
                        </div>
                    ))}
                </div>

                <div>
                    <InputBoxWraper>
                        <select
                            onChange={(e) => handleGenderChange(e.target.value)}
                            value={details.gender || defaultGenderValue}
                            className="w-full placeholder:text-slate-100 bg-transparent outline-none border-none"
                        >
                            {[defaultGenderValue, ...GENDERS_LIST]?.map((item, index) => (
                                <option key={index} value={item}>{item}</option>
                            ))}
                        </select>
                    </InputBoxWraper>
                    {errors.gender && (
                        <p className="text-sm text-red-500 mt-1">{errors.gender}</p>
                    )}
                </div>
            </div>

            <div className="my-5 flex flex-col gap-3">
                <p className=' font-semibold'>Getting to know you</p>
                {/* <div>
                    <InputBoxWraper>
                        <input
                            type="text"
                            className="bg-transparent outline-none border-none w-full"
                            placeholder="Enter your country"
                            value={details.country}
                            onChange={(e)=>updateCountry(e.target.value)}
                            
                        />
                    </InputBoxWraper>
                    {errors.country && (
                        <p className="text-sm text-red-500 mt-1">{errors.country}</p>
                    )}
                </div> */}


                {/* <div>
                    <InputBoxWraper>
                        <select
                            className="bg-transparent outline-none border-none w-full"
                            value={details.state}
                            onChange={(e) => handleInputChange(updateState, e.target.value, "state")}
                        >
                            <option value="">Select a state</option>
                            {stateData().map((state) => (
                                <option key={state} value={state}>
                                    {state}
                                </option>
                            ))}
                        </select>
                    </InputBoxWraper>
                    {errors.state && (
                        <p className="text-sm text-red-500 mt-1">{errors.state}</p>
                    )}
                </div> */}


            </div>
            <MobileNumberVerification email={details.email} updateCountry={updateCountry}
                details={details}
                handleInputChange={handleInputChange}
                updateState={updateState}
                updateCity={updateCity}
                updateMobile={updateMobile}
                errors={errors}
                isMobileNumberVerified={isMobileNumberVerified}
                setIsMobileNumberVerified={setIsMobileNumberVerified}
                flag={true}
            />
            {errors.mobile && (
                <p className="text-sm text-red-500 mt-1">{errors.mobile}</p>
            )}
            <ButtonWithIcon
                onButtonClick={handleContinue}
                text="Continue"
                classNames="p-4 text-white "
            />

        </div>
    );
};

export default FirstDetails;
